import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import AttivaCard from '../../../components/card/AttivaCard';
import useHandleErrors from '../../../hooks/useHandleErrors';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import { ExpirationService } from '../../../services/expiration/expirationService';
import ExpirationForm from '../ExpirationForm';

const pageHeader = {
    title: 'Crear Vencimiento',
    breadcrumb: [
        { name: 'Ventas' },
        { name: 'Gestión de contratos' },
        { href: menuRoutes.expirations.path, name: 'Vencimientos', },
        { name: 'Crear Vencimiento' },
    ],
};

export default function ExpirationCreate() {

    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = async (values: any) => {
        setLoading(true);
        try {
            const response = await (await (new ExpirationService()).createExpiration(values)).getResponseData();
            if (response.success) {
                setLoading(false);
                navigate(-1);
                setTimeout(() => { toast.success('Vencimiento creado correctamente') }, 100);
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error('Error al crear el vencimiento');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title='Datos Principales'>
                <ExpirationForm submit={handleSubmit} isLoading={loading} />
            </AttivaCard>
        </>
    );
}